import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { FormBuilder, FormGroup } from '@angular/forms'
import { select, Store } from '@ngrx/store'

import * as fromRoot from '@tv3/store/state'

/* Store Rental */
import { Rental, updateRentalCustomFields } from '@tokeet-frontend/tv3-platform'
import { isSavingCustom } from '@tokeet-frontend/tv3-platform'

/* Decorators */
import { SaveForm } from '@tokeet-frontend/tv3-platform'

/* Utils */
import { Destroyable } from '@tokeet-frontend/tv3-platform'
import { SyncMainUnitData, SyncMainUnitDataConfirmService } from '@tokeet-frontend/rentals'

@Component({
  selector: 'app-rental-details-custom-info',
  templateUrl: './rental-details-custom-info.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./rental-details-custom-info.component.scss'],
})
export class RentalDetailsCustomInfoComponent extends Destroyable {
  _rental: Rental
  @Input() set rental(r: Rental) {
    if (this._rental?.id !== r?.id) {
      this.setForm(r)
    }
    this._rental = r
  }
  get rental() {
    return this._rental
  }

  form = this.fb.group({
    custom1: [],
    custom2: [],
    custom3: [],
    custom4: [],
    custom5: [],
  })

  isFormInitialized = false

  isSavingCustom$ = this.store.pipe(select(isSavingCustom))

  constructor(
    private fb: FormBuilder,
    private store: Store<fromRoot.State>,
    private syncMainUnitDataConfirm: SyncMainUnitDataConfirmService
  ) {
    super()
  }

  save() {
    this.onSave(this.form)
  }

  @SaveForm()
  onSave(form: FormGroup) {
    const formValues = form.getRawValue()
    this.store.dispatch(updateRentalCustomFields({ rentalId: this.rental.id, payload: formValues }))

    this.syncMainUnitDataConfirm.tryToSyncData(this.rental, SyncMainUnitData.CustomInfo).subscribe()
  }

  private setForm(rental: Rental) {
    this.form.patchValue({
      custom1: rental.custom1 || '',
      custom2: rental.custom2 || '',
      custom3: rental.custom3 || '',
      custom4: rental.custom4 || '',
      custom5: rental.custom5 || '',
    })
  }
}
